<template>
  <div class="sons-merge-card">
    <div class="questions-details">
      <div class="title-container">
        <span class="title">חסר חשבון בנק שקשור לכרטיס:</span>
      </div>
      <div class="account">{{ formattedAccount }}</div>
      <img class="logo" :src="require(`@/assets/bank-logos-30/${logoFileName}`)">
      <div class="title lower-title">רוצה להוסיף אותו לתזרים?</div>
    </div>
    <div v-if="!shouldAddSource" class="question-actions">
      <riseup-button class="button-container" :variant="'primary'" :title="'כן! אני רוצה להוסיף'"
                   :action="() => setAddBankSource()"/>
      <riseup-button class="button-container" :variant="'secondary'" :title="'לא צריך להוסיף אותו'"
                   :action="() => setInputAndTrack(cardInputTypes.excluded)"/>
    </div>
    <div v-else>
      <source-selection
        :disabled="false"
        :selectionText="'באיזה בנק החשבון?'"
        :sources="bankSources"
        :sourceType="'bank'"
        :scrollable="true"
        :onlyExpanded="true"
        :addSource="setSource">
      </source-selection>
    </div>
    <card-bug-report class="bug-report-wrapper" :action="reportBug"></card-bug-report>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import BaseUI from 'base-ui';
import CardBugReport from '../../../../../../../base-components/card-parts/CardBugReport.vue';
import Segment from '../../../../../../../Segment';
import SourceSelection from '../../../../../../../base-components/credentials/credentials-selection-card/SourceSelection.vue';
import sourceToLogs from '../../../../../../../utils/sourcesToLogo';
import SourceFields from '../../../../../../../mixins/SourceFields.vue';

export default {
  name: 'SonsMergeCard',
  mixins: [SourceFields],
  components: {
    CardBugReport,
    SourceSelection,
    RiseupButton: BaseUI.RiseupButton,
  },
  props: ['question'],
  data() {
    return {
      addBankSource: false,
    };
  },
  computed: {
    ...mapState('mergeInvestigationQuestions', ['cardInputTypes']),
    logoFileName() {
      return sourceToLogs[this.question.source];
    },
    formattedAccount() {
      return `${this.question.account} ********`;
    },
    shouldAddSource() {
      const hasSource = !!this.question.bankSource;
      return this.addBankSource && !hasSource;
    },
    bankSources() {
      return _.filter(this.allSourceFields, source => source.type === 'bank' && !source.hidden);
    },
  },
  methods: {
    ...mapActions('mergeInvestigationQuestions', ['setSonQuestionInput', 'addSonSource']),
    setAddBankSource() {
      this.addBankSource = true;
    },
    setInputAndTrack(input) {
      Segment.trackUserInteraction('SonsInvestigationClicked', {
        question: {
          chunkId: this.question.chunkId,
          account: this.question.account,
          source: this.question.source,
          billingDate: this.question.billingDate,
        },
        input,
      });
      this.setSonQuestionInput({ chunkId: this.question.chunkId, input });
    },
    setSource({ source }) {
      this.setInputAndTrack(this.cardInputTypes.addCreds);
      this.addSonSource({ chunkId: this.question.chunkId, source });
    },
    reportBug() {
      this.setInputAndTrack(this.cardInputTypes.bug);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../scss/mixins';

  .sons-merge-card {
    @include card;
    padding: 16px 24px;

    .questions-details {
      margin-bottom: 16px;

      .title-container {
        line-height: 1em;
        margin-bottom: 12px;

        .icon {
          position: relative;
          bottom: -1px;
          margin-left: 5px;
        }
      }

      .title {
        font-size: 20px;
        line-height: 20px;
      }
      .lower-title {
        margin: 18px 0 0;
      }

      .account {
        line-height: 1em;
        font-family: SimplerProBold;
        font-size: 35px;
        margin: 18px 0 0;
      }

      .logo {
        height: 40px;
      }
    }

    .question-actions {
      .button-container {
        margin-bottom: 16px;
      }
    }
  .bug-report-wrapper {
    margin-top: 8px;
  }
}

</style>
